import React from "react";
import { motion } from "framer-motion";
import SingleProduct from "../components/SingleProduct";
import { pageTransition, pageZoom } from "../utils/styleUtils";

function ProductScreen() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageZoom}
      transition={pageTransition}
    >
      <SingleProduct />
    </motion.div>
  );
}
export default ProductScreen;
